import api from '../utils/api';
import { 
  SoapNote, 
  SoapTemplate, 
  CreateSoapNoteDto, 
  UpdateSoapNoteDto, 
  CompleteSoapNoteDto,
  SoapNoteStatus 
} from '../types/soap';
import { VoiceToSoapRequest, VoiceToSoapResponse } from '../types/voice';

export const soapNotesService = {
  // SOAP Notes CRUD
  create: async (data: CreateSoapNoteDto): Promise<SoapNote> => {
    const response = await api.post('/soap-notes', data);
    return response.data;
  },

  findAll: async (params?: {
    horseId?: string;
    providerId?: string;
    status?: SoapNoteStatus;
    startDate?: string;
    endDate?: string;
  }): Promise<SoapNote[]> => {
    const response = await api.get('/soap-notes', { params });
    return response.data;
  },

  findOne: async (id: string): Promise<SoapNote> => {
    const response = await api.get(`/soap-notes/${id}`);
    return response.data;
  },

  update: async (id: string, data: UpdateSoapNoteDto): Promise<SoapNote> => {
    const response = await api.patch(`/soap-notes/${id}`, data);
    return response.data;
  },

  upsert: async (data: CreateSoapNoteDto): Promise<SoapNote> => {
    const response = await api.put('/soap-notes/upsert', data);
    return response.data;
  },

  complete: async (id: string, data: CompleteSoapNoteDto): Promise<SoapNote> => {
    const response = await api.post(`/soap-notes/${id}/complete`, data);
    return response.data;
  },

  archive: async (id: string): Promise<void> => {
    await api.delete(`/soap-notes/${id}`);
  },

  // Templates
  getTemplates: async (): Promise<SoapTemplate[]> => {
    const response = await api.get('/soap-notes/templates');
    return response.data;
  },

  getTemplate: async (id: string): Promise<SoapTemplate> => {
    const response = await api.get(`/soap-notes/templates/${id}`);
    return response.data;
  },

  createTemplate: async (data: Partial<SoapTemplate>): Promise<SoapTemplate> => {
    const response = await api.post('/soap-notes/templates', data);
    return response.data;
  },

  updateTemplate: async (id: string, data: Partial<SoapTemplate>): Promise<SoapTemplate> => {
    const response = await api.patch(`/soap-notes/templates/${id}`, data);
    return response.data;
  },

  deleteTemplate: async (id: string): Promise<void> => {
    await api.delete(`/soap-notes/templates/${id}`);
  },

  // Voice-to-SOAP AI Processing
  processVoiceToSoap: async (data: VoiceToSoapRequest): Promise<VoiceToSoapResponse> => {
    const response = await api.post('/ai/voice-to-soap', data);
    return response.data;
  },
};
